import { render, staticRenderFns } from "./receiptDetail.vue?vue&type=template&id=45b8746a&scoped=true&"
import script from "./receiptDetail.vue?vue&type=script&lang=js&"
export * from "./receiptDetail.vue?vue&type=script&lang=js&"
import style0 from "./receiptDetail.vue?vue&type=style&index=0&id=45b8746a&lang=scss&scoped=true&"
import style1 from "./receiptDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b8746a",
  null
  
)

export default component.exports